import { ChangeDetectionStrategy, Component, type ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';

@Component({
    styleUrls: ['./shared-ui-infinite-scrolling.component.scss'],
    selector: 'shared-ui-infinite-scrolling',
    templateUrl: 'shared-ui-infinite-scrolling.component.html',
    exportAs: 'sharedUiInfiniteScrolling',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [InfiniteScrollDirective]
})
export class SharedUiInfiniteScrollingComponent {
    @Input() scrollContent?: ElementRef;
    @Input() completed: boolean = false;
    @Input() infiniteScrollDistance: number = 2;
    @Input() infiniteScrollThrottle: number = 50;

    @Output() scrolled: EventEmitter<void> = new EventEmitter();

    onScrollDown() {
        if (this.completed) {
            return;
        }
        this.scrolled.emit();
    }
}
